function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
}

const updateCartNote = debounce((note) => {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
  })
    .then((response) => response.json())
    .then((data) => console.log("Cart note updated:", data.note))
    .catch((error) => console.error("Error updating cart note:", error));
}, 500);

document.addEventListener("DOMContentLoaded", () => {
  if (typeof BSS_B2B !== "undefined") {
    updateCartNote("")
    document
      ?.getElementById("CartSpecialInstructions")
      ?.addEventListener("input", (event) => {
        updateCartNote(event.target.value);
      });
  }
}); 